// Stroke/drawing colors (matches extension palette)
export const COLORS = [
  "#4A4A4A", // dark grey
  "#F48FB1", // salmon/pink
  "#FFB74D", // orange
  "#FFF176", // yellow
  "#81C784", // green
  "#64B5F6", // blue
  "#CE93D8", // purple
  "#FF0000", // red
  "#000000", // black
  "#FFFFFF", // white
];

// Fill/background colors for text (includes "no fill")
export const FILL_COLORS = [
  null,       // no fill (transparent)
  "#4A4A4A", // dark grey
  "#F48FB1", // salmon/pink
  "#FFB74D", // orange
  "#FFF176", // yellow
  "#81C784", // green
  "#64B5F6", // blue
  "#CE93D8", // purple
];

export const HIGHLIGHT_DEFAULT_COLOR = "#FFEB3B";

export const DEFAULT_THICKNESS = 2;
export const MIN_THICKNESS = 1;
export const MAX_THICKNESS = 20;

export const MIN_BLUR = 1;
export const MAX_BLUR = 20;
export const DEFAULT_BLUR = 5;

export const ASPECT_RATIOS = {
  free: null,
  "1:1": 1,
  "4:3": 4 / 3,
  "16:9": 16 / 9,
  "3:2": 3 / 2,
} as const;

export const FONT_FAMILIES = [
  "Arial",
  "Helvetica",
  "Times New Roman",
  "Georgia",
  "Courier New",
  "Verdana",
  "Impact",
  "Comic Sans MS",
];

export const DEFAULT_FONT_SIZE = 32;
export const MIN_FONT_SIZE = 8;
export const MAX_FONT_SIZE = 120;
